import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UnitMasterService } from '../../services/unit-master-service';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { UnitModel } from '../../models/unit.model';

@Component({
  selector: 'app-unit-master',
  templateUrl: './unit-master.component.html',
  styleUrls: ['./unit-master.component.css'],
})
export class UnitMasterComponent implements OnInit, AfterViewInit {
  
  // Form fields
  unitId: number | null = null;
  unitName: string = '';
  isActive: boolean = true;

  // Table setup
  displayedColumns: string[] = ['srNo', 'unitName', 'status', 'actions'];
  dataSource = new MatTableDataSource<UnitModel>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private _unitService: UnitMasterService,
    private _utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    this.lFN_GetUnitList();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  lFN_GetUnitList(): void {
    this._utilityService.lFN_ShowLoader();
    this._unitService.lFN_GetUnitList().subscribe({
      next: (res: any) => {
        this._utilityService.lFN_HideLoader();
        const parsed = JSON.parse(res.body);
        this.dataSource.data = parsed?.data || [];
      },
      error: () => {
        this._utilityService.lFN_HideLoader();
        this._utilityService.lFN_ErrorToaster('Failed to load unit list', 'Error');
      }
    });
  }

  lFN_Save(): void {
    if (!this.unitName || this.unitName.trim() === '') {
      this._utilityService.lFN_WarningToaster('Unit Name is required', 'Warning');
      return;
    }

    this.unitName = this.unitName.trim().toUpperCase();

    const clientMaster = JSON.parse(sessionStorage.getItem('client_master') || '{}');
    const clientId = clientMaster.clientId || 1;

    const payload: UnitModel = {
      unitId: this.unitId as number,
      clientId: clientId,
      unitName: this.unitName,
      unitIsActive: this.isActive ? 'YES' : 'NO',
    };

    this._utilityService.lFN_ShowLoader();
    this._unitService.lFN_SaveUnit(payload).subscribe({
      next: (res: any) => {
        this._utilityService.lFN_HideLoader();
        this._utilityService.lFN_SuccessToaster(res.body?.message || 'Unit saved successfully', 'Success');
        this.lFN_Reset();
        this.lFN_GetUnitList();
      },
      error: (err: any) => {
        this._utilityService.lFN_HideLoader();
        this._utilityService.lFN_ErrorToaster(err.error?.message || 'Failed to save unit', 'Error');
      }
    });
  }

  lFN_Reset(): void {
    this.unitId = null;
    this.unitName = '';
    this.isActive = true;
  }

  lFN_Edit(row: UnitModel): void {
    this._utilityService.lFN_ShowLoader();
    this._unitService.lFN_GetUnitById(row.unitId).subscribe({
      next: (res: any) => {
        this._utilityService.lFN_HideLoader();
        const parsed = JSON.parse(res.body);
        const unitData: UnitModel = parsed?.data;
        if (unitData) {
          this.unitId = unitData.unitId;
          this.unitName = unitData.unitName;
          this.isActive = unitData.unitIsActive === 'YES';
        } else {
          this._utilityService.lFN_ErrorToaster('Failed to fetch unit details', 'Error');
        }
      },
      error: (err: any) => {
        this._utilityService.lFN_HideLoader();
        this._utilityService.lFN_ErrorToaster(err.error?.message || 'Failed to fetch unit details', 'Error');
      }
    });
  }

  lFN_ToggleUnitStatus(unit: UnitModel): void {
    const newStatus: 'YES' | 'NO' =
      unit.unitIsActive === 'YES' ? 'NO' : 'YES';

    const dialogData = {
      title: `Change Status - ${unit.unitName}`,
      message: `Are you sure you want to change unit status to ${newStatus}?`,
      buttons: [
        { label: 'Yes', value: true, color: 'primary' },
        { label: 'No', value: false, color: 'warn' },
      ],
    };

    this._utilityService
      .lFN_ShowConfirmationDialog(
        dialogData.title,
        dialogData.message,
        dialogData.buttons
      )
      .subscribe((confirmed) => {
        if (!confirmed) return;
        
        this._utilityService.lFN_ShowLoader();
       
        this._unitService
          .lFN_ToggleUnitStatus(unit.unitId)
          .subscribe({
            next: () => {
              // ✅ Optimistic UI update
              unit.unitIsActive = newStatus;

              this._utilityService.lFN_SuccessToaster(
                'Unit status updated successfully',
                'Success'
              );
            },
            error: () => {
              this._utilityService.lFN_ErrorToaster(
                'Failed to update unit status',
                'Error'
              );
            },
            complete: () => {
              this._utilityService.lFN_HideLoader();
            },
          });
      });
  }
}
